import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { updateProductFilters } from "../../../redux/action/productFiltersAction";
import * as P from "../../products/list/Proucts-list-styles";
import { isLoaded, isLoading } from "../../../redux/action/loading";
import { numberCheck } from "@common/NumberCheck"; // numberCheck 함수 import

const Tags = ({
  updateProductFilters,
  productFilters,
  categoryHash,
  categoryName,
  dummyList,
  isLoading,
  isLoaded,
}) => {
  const router = useRouter();
  const [selectedTags, setSelectedTags] = useState("");
  const [categorySlug, setCategorySlug] = useState("");
  // 코드에서 slug를 찾는 함수
  const findCategorySlug = (code) => {
    if (!dummyList || !dummyList.category) return "";
    const category = dummyList.category.find((cat) => cat.code === code);
    return category ? category.ename : "";
  };

  // 현재 slug 경로를 찾는 함수
  const getCurrentSlug = () => {
    if (router.query.slug) return router.query.slug;
    if (router.query.code) return findCategorySlug(router.query.code);
    return "";
  };

  // 현재 해시태그 가져오기 - URL 경로 분석
  const getCurrentHash = () => {
    try {
      // URL 디코딩하여 경로 구조 분석
      const decodedPath = decodeURIComponent(router.asPath);
      const pathParts = decodedPath.split("/").filter((part) => part);

      // /products/[slug]/[hash]/ 형태인 경우
      if (pathParts.length >= 3 && pathParts[0] === "products") {
        const hash = pathParts[2];
        // 쿼리 파라미터나 다른 특수문자 제거
        const cleanHash = hash.split("?")[0].split("#")[0];

        // 숫자형 해시는 페이지 번호로 처리 (전체보기로 간주)
        if (numberCheck(cleanHash)) {
          return "";
        }

        return cleanHash;
      }
      // 쿼리 파라미터로부터 해시태그 가져오기
      else if (router.query.hash) {
        // 숫자형 해시는 페이지 번호로 처리 (전체보기로 간주)
        if (numberCheck(router.query.hash)) {
          return "";
        }

        return router.query.hash;
      }
    } catch (error) {
      console.error("URL 파싱 중 오류 발생:", error);
      // 쿼리 파라미터 사용 시도
      if (router.query.hash) {
        // 숫자형 해시는 페이지 번호로 처리 (전체보기로 간주)
        if (numberCheck(router.query.hash)) {
          return "";
        }

        return router.query.hash;
      }
    }

    return "";
  };

  const handleClick = (target) => {
    setSelectedTags(target);

    const slug = getCurrentSlug();
    if (!slug) return;

    // 전체보기인 경우 해시태그 경로 생략
    if (target === "") {
      router.push(`/products/${slug}`);
    } else {
      router.push(`/products/${slug}/${target}`);
    }
  };

  useEffect(() => {
    if (!router.isReady) return;

    // 현재 slug 설정
    setCategorySlug(getCurrentSlug());

    // 현재 활성화된 해시태그 결정
    const currentHash = getCurrentHash();

    if (selectedTags !== currentHash) {
      setSelectedTags(currentHash || "");
      if (categoryHash) {
        updateProductFilters({ hash: currentHash || "" });
      }
    }
  }, [router.isReady, router.query, router.asPath, categoryHash, dummyList]);

  useEffect(() => {
    if (selectedTags) {
      updateProductFilters({ hash: selectedTags });
    }
  }, [selectedTags]);

  // 현재 해시태그 - 렌더링 시마다 계산
  const currentHash = getCurrentHash();

  return (
    <>
      <P.MenuList>
        <li
          className="hover-up"
          onClick={() => handleClick("")}
          style={{ cursor: "pointer" }}
        >
          <a
            className={currentHash === "" ? "cat-item text-brand" : "cat-item"}
          >
            <i className="fi-rs-caret-right mr-5" /> {"전체보기"}
          </a>
        </li>
        {categoryHash?.length > 0 &&
          categoryHash.map((tag, i) => (
            <li
              className="hover-up"
              onClick={() => handleClick(tag)}
              key={i}
              style={{ cursor: "pointer" }}
            >
              <a
                className={
                  currentHash === tag ? "cat-item text-brand" : "cat-item"
                }
              >
                <i className="fi-rs-caret-right mr-5" /> {tag}
              </a>
            </li>
          ))}
      </P.MenuList>
    </>
  );
};

const mapStateToProps = (state) => ({
  productFilters: state.productFilters,
  dummyList: state.dummyList,
});

const mapDidpatchToProps = {
  updateProductFilters,
  isLoading,
  isLoaded,
};

export default connect(mapStateToProps, mapDidpatchToProps)(Tags);
